import React, { Component } from "react";

import { Button, Modal, Popconfirm } from "antd";
import { Tabs } from "antd";
import { message } from "antd";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import instance from "@/store/actions/instance";
import StockUpdateOrderInvoice from "./StockUpdateOrderInvoice";
import BarcodeReader from "react-barcode-reader";
import { error } from "jquery";

const { TabPane } = Tabs;
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

class StockUpdateOrderDetailsModal extends Component {
  state = {
    saveLoading: false,
    loading: true,
    products: [],

    editMode: false,
    originalProducts: [],
  };
  fetchStockUpdateOrderDetails = async () => {
    const { t, selectedOrder, orderDetailsIndex } = this.props;
    try {
      const res = await instance.get(
        `get_stock_update_orders/${selectedOrder.id}`
      );

      this.setState({
        loading: false,
        products: res.data.products,
        originalProducts: res.data.products.map((e) => {
          //To have a new reference
          return { ...e };
        }),
      });
      this.props.updateOrder?.(res.data.order);
    } catch (err) {
      if (err.response && err.response.status == 403)
        message.error(t("AccessDeniedMessage"));
      else message.error(t("SomethingWentWrong"));
    }
  };

  componentDidMount = () => {
    this.fetchStockUpdateOrderDetails();
  };
  updateButtonDisabled = () => {
    const { products } = this.state;
    return products.some((product) => product.counted_quantity === null);
  };
  changeStatus = async (updateInventory = false, status = "New") => {
    this.setState({ saveLoading: true });
    const { t, selectedOrder } = this.props;
    const { products } = this.state;
    try {
      const res = await instance.post(`/change_stock_update_order_status/`, {
        oid: selectedOrder.id,
        updateInventory: updateInventory,
        products: products,
        status,
      });

      selectedOrder.status = status;
      message.success(t("Changed successfully"));
      this.props.onClose();
    } catch (err) {
      if (err.response && err.response.status == 403)
        message.error(t("AccessDeniedMessage"));
      else message.error(err.response?.data?.error || t("SomethingWentWrong"));
    }
    this.setState({ saveLoading: false });
  };
  handleProductScan = (productBarcode) => {
    const { products } = this.state;
    const newProductIndex = products.findIndex(
      (p) => p.barcode === productBarcode
    );
    if (newProductIndex != -1) {
      const newProducts = [...this.props.products];
      newProducts[newProductIndex].counted_quantity += 1;
      this.setState({ products: newProducts });
    }
  };
  updateStockUpdateOrder = async () => {
    const { t, selectedOrder } = this.props;
    const { products } = this.state;
    try {
      this.setState({ loading: true });

      const res = await instance.post(`update_stock_update_order/`, {
        orderId: selectedOrder.id,
        products: products,
      });

      this.fetchStockUpdateOrderDetails();
      this.setState({
        editMode: false,
      });
      message.success(t("Changed successfully"));
    } catch (err) {
      this.setState({
        loading: false,
      });
      if (err.response && err.response.status == 403)
        message.error(t("AccessDeniedMessage"));
      else message.error(err.response?.data?.error || t("SomethingWentWrong"));
    }
  };

  setEditMode = (newEditMode) => {
    this.setState({ editMode: newEditMode });
  };
  render() {
    const { t, config, selectedOrder, permissions, isViewOnly } = this.props;
    const { loading, products, saveLoading, originalProducts, editMode } =
      this.state;

    return (
      <Modal
        destroyOnClose={true}
        maskClosable={false}
        title={
          <div
            className="ant-modal-title"
            style={{ textAlign: config.direction == "rtl" ? "right" : "left" }}
          >
            {t("Order details")}
          </div>
        }
        open={true}
        cancelText={t("Close")}
        okButtonProps={{
          style: {
            display: "none",
          },
        }}
        footer={[
          !loading &&
            !isViewOnly &&
            (editMode ? (
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Button
                  type="danger"
                  onClick={() => {
                    this.setState({
                      products: originalProducts.map((e) => {
                        //To have a new reference
                        return { ...e };
                      }),
                    });
                    this.setEditMode(false);
                  }}
                  style={{
                    margin: 5,
                  }}
                >
                  {t("Cancel Updates")}
                </Button>

                <Button
                  type="primary"
                  onClick={() => this.updateStockUpdateOrder()}
                  style={{ margin: "5px" }}
                >
                  {t("Update")}
                </Button>
              </div>
            ) : (
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                {permissions.can_create_transfer_orders && (
                  <div>
                    <Button
                      onClick={() =>
                        this.props.duplicateOrder({
                          products: products,
                          order: selectedOrder,
                        })
                      }
                      style={{
                        margin: 5,
                      }}
                    >
                      {t("Duplicate Count")}
                    </Button>
                    {permissions.can_update_stock_update_orders &&
                      selectedOrder.status === "New" && (
                        <Popconfirm
                          title={t("Are you sure you want to cancel?")}
                          onConfirm={() =>
                            this.changeStatus(false, "Cancelled")
                          }
                          placement={
                            config.direction === "rtl" ? "topRight" : "topLeft"
                          }
                          okText={t("Yes")}
                          cancelText={t("No")}
                        >
                          <Button type="danger" style={{ margin: "5px" }}>
                            {t("Cancel")}
                          </Button>
                        </Popconfirm>
                      )}
                  </div>
                )}

                {permissions.can_update_stock_update_orders &&
                  selectedOrder.status === "New" && (
                    <div style={{ display: "flex", gap: 10 }}>
                      <Button
                        key="submit"
                        type="primary"
                        loading={saveLoading}
                        onClick={() => this.changeStatus(false, "New")}
                      >
                        {t("Save")}
                      </Button>

                      {permissions.can_complete_stock_update_orders && (
                        <Popconfirm
                          title={t(
                            "Are you sure you want to update the inventory?"
                          )}
                          onConfirm={() => this.changeStatus(true, "Complete")}
                          okText={t("Update")}
                          cancelText={t("Close")}
                          disabled={this.updateButtonDisabled()}
                        >
                          <Button
                            key="link"
                            type="primary"
                            loading={saveLoading}
                            disabled={this.updateButtonDisabled()}
                          >
                            {t("Save & update inventory")}
                          </Button>
                        </Popconfirm>
                      )}
                    </div>
                  )}
              </div>
            )),
        ]}
        bodyStyle={{
          paddingTop: 0,
          width: "auto",
          textAlign: config.direction == "ltr" ? "left" : "right",
        }}
        width={900}
        onCancel={!saveLoading && this.props.onClose}
      >
        <BarcodeReader onScan={this.handleProductScan} />

        {loading ? (
          <div className="my-5 text-center">
            <Spin indicator={antIcon} />
          </div>
        ) : (
          <StockUpdateOrderInvoice
            selectedOrder={selectedOrder}
            products={products}
            setProducts={(newProducts) =>
              this.setState({ products: newProducts })
            }
            isViewOnly={isViewOnly}
            editMode={editMode}
            setEditMode={this.setEditMode}
          />
        )}
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    permissions: state.auth.permissions,
    settings: state.auth.settings,
    config: state.config,
    is_staff: state.auth.is_staff,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces()(StockUpdateOrderDetailsModal));
